export default __webpack_public_path__ + "static/media/shopping-list-3.ef1b46a4.svg";